
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"912","height":"912","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_f_2180_25507)"}},[_c('circle',{attrs:{"cx":"456","cy":"456","r":"325.338","transform":"rotate(-4.23 456 456)","stroke":"#88C0B3","stroke-opacity":".68","stroke-width":"100"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_f_2180_25507","x":".645","y":".645","width":"910.711","height":"910.71","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"40","result":"effect1_foregroundBlur_2180_25507"}})])])])
          )
        }
      }
    